import React, { useState, useEffect } from "react";
import Sliderimgone from "../Assets/Images/slider-image-1.png";
import Sliderimgtwo from "../Assets/Images/slider-image-2.png";
import Sliderimgthree from "../Assets/Images/slider-image-3.png";
import TiltedArrow from "../Assets/Images/Tiltediconforslider.svg";
import "../Assets/Styles/SliderSection.css";
import useScreenWidth from "../Hooks/useScreenWidth";

const SliderSection = ({ isRectangular = false }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: "Always by your side,",
      subtitle: "only a click away.",
      tag: "Telehealth",
      image: Sliderimgtwo,
    },
    {
      title: "Always by your side,",
      subtitle: "only a click away.",
      tag: "Mental Health Coaching",
      image: Sliderimgone,
    },
    {
      title: "Always by your side,",
      subtitle: "only a click away.",
      tag: "Nutritionist",
      image: Sliderimgthree,
    },
  ];

  // Auto-slide functionality
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  const screenSize = useScreenWidth();
  const isMobileDevice = screenSize < 1024;

  return (
    <>
      <div
        id="services"
        className={`relative w-full overflow-hidden ${
          isRectangular || isMobileDevice ? "" : "container"
        }`}
      >
        {isMobileDevice ? (
          <>
            <h4 className="text-[1.45rem] md:text-[2rem] !leading-tight px-4 md:px-8 mt-4 font-bold mb-2 slider-text-title text-black">
              Always by your side,
              <br />
              only a click away
            </h4>
          </>
        ) : (
          <></>
        )}

        {/* Rounded container */}
        <div
          className={`slider-wrapper relative aspect-[10/9]  overflow-hidden ${
            isRectangular || isMobileDevice
              ? "md:aspect-[18/9]"
              : "rounded-full md:aspect-[18/9]"
          }`}
        >
          {/* Slides container */}
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`absolute top-0 left-0 w-full ${
                isRectangular
                  ? "h-screen"
                  : "h-full"
              }  transition-opacity duration-1000 ease-in-out ${
                currentSlide === index ? "opacity-100" : "opacity-0"
              }`}
            >
              {/* Image and overlay */}
              <div className={`relative w-full ${
                isRectangular
                  ? "h-screen"
                  : "h-full"
              }`}  >
                <img
                  src={slide.image}
                  alt={slide.title}
                  className={`w-full ${
                isRectangular
                  ? "h-screen"
                  : "h-full"}
                 object-cover`}
                />
                <div className="absolute inset-0 " />
              </div>
              <div> </div>
              {/* Content */}
              <div
                className={`absolute inset-0 flex flex-col ${
                  isRectangular
                    ? "container justify-end py-8 md:py-16"
                    : "justify-center p-8 md:p-16"
                }`}
              >
                <div
                  className={`max-w-xl text-white ${
                    isRectangular ? "pb-[10%] lg:pb-[17%]" : ""
                  }`}
                >
                  {!isMobileDevice ? (
                    <>
                      <h2 className="text-3xl md:text-4xl lg:text-custom-40px font-bold mb-2 slider-text-title text-white">
                        {slide.title}
                      </h2>{" "}
                      <h3
                        className="text-2xl md:text-3xl lg:text-4xl font-bold mb-0 slider-text-title text-white"
                        style={{ fontSize: "40px" }}
                      >
                        {slide.subtitle}
                      </h3>
                    </>
                  ) : (
                    <></>
                  )}

                  <div className="inline-flex items-center space-x-2 rounded-full px-4 py-2 sliderbtn right-[140px]">
                    <span className="text-sm md:text-base text-white">
                      {slide.tag}
                    </span>
                    <span>
                      <img src={TiltedArrow} alt="" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Health Services */}
    </>
  );
};

export default SliderSection;
